import PropTypes from 'prop-types';

const StatisticsDeleteIcon = ({ className, size = 17 }) => (
	<svg
		className={className}
		width={size}
		height={size}
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'
	>
		<path d='M3.35 4.85h9.3' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
		<path
			d='M5.95 4.85V4a.95.95 0 0 1 .95-.95h2.2a.95.95 0 0 1 .95.95v.85'
			stroke='currentColor'
			strokeWidth='1.4'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path
			d='M4.95 4.85v7.45a.95.95 0 0 0 .95.95h4.2a.95.95 0 0 0 .95-.95V4.85'
			stroke='currentColor'
			strokeWidth='1.4'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<path d='M6.75 7.35v3.55' stroke='currentColor' strokeWidth='1.25' strokeLinecap='round' opacity='0.5' />
		<path d='M9.25 7.35v3.55' stroke='currentColor' strokeWidth='1.25' strokeLinecap='round' opacity='0.5' />
	</svg>
);

StatisticsDeleteIcon.propTypes = {
	className: PropTypes.string,
	size: PropTypes.number,
};

export default StatisticsDeleteIcon;
